



















import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';

@Component({})
export default class PlayersOnline extends Vue {
  @Prop()
  private players: any;

  @Prop()
  private user: any;

  get playersOnline(): any[] {
    return this.players.filter(
      ({ connectionId }: { connectionId: string }) => connectionId !== this.user.connectionId,
    );
  }
}
